import { render, staticRenderFns } from "./myContractDetails1.vue?vue&type=template&id=61927d80&scoped=true"
import script from "./myContractDetails1.vue?vue&type=script&lang=js"
export * from "./myContractDetails1.vue?vue&type=script&lang=js"
import style0 from "./myContractDetails1.vue?vue&type=style&index=0&id=61927d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61927d80",
  null
  
)

export default component.exports